module.exports = ".container {\n  display: flex;\n}\n\n.demoButton {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n"